import util from '../util'

let controller = 'ConsultaFavorecidos'
export default Object.assign({}, util.GetCrud(controller, ['get', 'getall']), {
    ConsultaFavorecido: function (dto) {
        return util.Axios.GetAll(controller + '/ConsultaFavorecido', dto)
    },
    ObterDetalhes: function (codigoFavorecido) {
        return util.Axios.GetAll(controller + '/Detalhes/' + codigoFavorecido)
    }
})
